// extracted by mini-css-extract-plugin
export default {"menuItem":"OfficeMenu_menuItem__AWz6V","menuItemActive":"OfficeMenu_menuItemActive__O+i2H"};